import { Feed } from '../model/feed';
import { ConfigGridAlias } from '../model/config-grid-alias';
import { Module } from '../model/module';

export class ConfigurationsRequest {
    module: Module;
    feeds: Feed[];
    fields: ConfigGridAlias[];
}
